var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('p',{staticClass:"text-inherit hover:text-primary text-lg font-bold",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();}}},[_vm._v("\n    "+_vm._s(new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }).format(_vm.params.value))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }